/**
 * Selector de tienda multitienda.
 * - 1 tienda: fijada (sin select)
 * - Varias: modal al abrir sesión + select restringido a las asignadas
 * - Admin sin asignación: lista completa
 */

const SESSION_TIENDA_KEY = 'poskn_session_tienda_id';
const LOCAL_TIENDA_KEY = 'poskn_tienda_id';

function escHtml(s) {
	return String(s == null ? '' : s)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

function normalizeAssigned(raw) {
	return (raw || []).map((t) => {
		const id = parseInt(t.id != null ? t.id : t.tienda_id, 10);
		return {
			id: Number.isNaN(id) ? 0 : id,
			nombre: t.nombre || (id === 0 ? 'Tienda principal' : `Tienda #${id}`),
			codigo: t.codigo || '',
		};
	});
}

function readSessionTienda() {
	try {
		const v = sessionStorage.getItem(SESSION_TIENDA_KEY);
		if (v === null || v === '') return null;
		const n = parseInt(v, 10);
		return Number.isNaN(n) ? null : n;
	} catch (e) {
		return null;
	}
}

function writeSessionTienda(id) {
	try {
		sessionStorage.setItem(SESSION_TIENDA_KEY, String(id));
	} catch (e) {
		/* ignore */
	}
	try {
		localStorage.setItem(LOCAL_TIENDA_KEY, String(id));
	} catch (e) {
		/* ignore */
	}
}

function applyTienda(win, tienda, opts) {
	const id = parseInt(tienda.id, 10);
	const nombre = tienda.nombre || '';
	win.posknTiendaSeleccionada = { id: Number.isNaN(id) ? 0 : id, nombre };
	writeSessionTienda(win.posknTiendaSeleccionada.id);

	const sel = document.getElementById('tienda-selector');
	if (sel) {
		const val = String(win.posknTiendaSeleccionada.id);
		if (sel.querySelector(`option[value="${val}"]`)) {
			sel.value = val;
		}
	}

	const label = document.getElementById('poskn-tienda-activa-label');
	if (label) {
		label.textContent = nombre || 'Tienda';
	}

	if (typeof win.cargarStockTiendaPOS === 'function') {
		win.cargarStockTiendaPOS(win.posknTiendaSeleccionada.id);
	}
	if (win.mesasData && Array.isArray(win.mesasData)) {
		win.mesasData.splice(0, win.mesasData.length);
	}
	// Al cambiar tienda: no reutilizar terminal en memoria de otra tienda.
	win.posknRegisterSeleccionado = null;
	if (typeof win.cargarRegisters === 'function' && !(opts && opts.skipRegisters)) {
		setTimeout(() => {
			win.cargarRegisters();
			if (typeof win.cargarEstadoCaja === 'function') {
				win.cargarEstadoCaja();
			}
			if (typeof win.cargarMesas === 'function') {
				win.cargarMesas();
			}
		}, 200);
	}
}

function ensureModalStyles() {
	if (document.getElementById('poskn-tienda-session-styles')) return;
	const style = document.createElement('style');
	style.id = 'poskn-tienda-session-styles';
	style.textContent = `
#poskn-modal-elige-tienda{display:none;position:fixed;inset:0;z-index:100050;background:rgba(15,23,42,.55);align-items:center;justify-content:center;padding:16px}
#poskn-modal-elige-tienda.show{display:flex}
#poskn-modal-elige-tienda .box{background:#fff;border-radius:14px;max-width:440px;width:100%;padding:22px 20px;box-shadow:0 18px 50px rgba(0,0,0,.25)}
#poskn-modal-elige-tienda h3{margin:0 0 6px;font-size:18px}
#poskn-modal-elige-tienda p{margin:0 0 14px;color:#546e7a;font-size:13px;line-height:1.45}
#poskn-modal-elige-tienda .lista{display:flex;flex-direction:column;gap:8px}
#poskn-modal-elige-tienda .btn-tienda{display:block;width:100%;text-align:left;padding:12px 14px;border:2px solid #cfd8dc;border-radius:10px;background:#fafafa;cursor:pointer;font-size:14px;font-weight:700;color:#1d2327}
#poskn-modal-elige-tienda .btn-tienda:hover,#poskn-modal-elige-tienda .btn-tienda:focus{border-color:#2e7d32;background:#e8f5e9;outline:none}
#poskn-modal-elige-tienda .hint{margin-top:12px;font-size:11px;color:#78909c}
#poskn-btn-cambiar-tienda{margin-left:4px;padding:2px 8px;font-size:10px;border-radius:4px;border:1px solid #90a4ae;background:#fff;cursor:pointer;font-weight:600}
`;
	document.head.appendChild(style);
}

function showTiendaSessionModal(win, assigned, onPick) {
	ensureModalStyles();
	let modal = document.getElementById('poskn-modal-elige-tienda');
	if (!modal) {
		modal = document.createElement('div');
		modal.id = 'poskn-modal-elige-tienda';
		modal.setAttribute('role', 'dialog');
		modal.setAttribute('aria-modal', 'true');
		modal.innerHTML = `
			<div class="box">
				<h3>¿En qué tienda vas a facturar?</h3>
				<p>Elige la tienda de esta sesión. Solo verás sus productos, stock y mesas.</p>
				<div class="lista" id="poskn-lista-tiendas-session"></div>
				<p class="hint">Puedes cambiar después con el botón «Cambiar» junto a la tienda.</p>
			</div>`;
		document.body.appendChild(modal);
	}
	const lista = modal.querySelector('#poskn-lista-tiendas-session');
	lista.innerHTML = assigned
		.map(
			(t) =>
				`<button type="button" class="btn-tienda" data-id="${t.id}" data-nombre="${escHtml(t.nombre)}">🏪 ${escHtml(t.nombre)}</button>`,
		)
		.join('');
	lista.onclick = (e) => {
		const btn = e.target.closest('.btn-tienda');
		if (!btn) return;
		const id = parseInt(btn.getAttribute('data-id'), 10);
		const nombre = btn.getAttribute('data-nombre') || '';
		modal.classList.remove('show');
		onPick({ id: Number.isNaN(id) ? 0 : id, nombre });
	};
	modal.classList.add('show');
}

function fillAssignedSelect(assigned) {
	const sel = document.getElementById('tienda-selector');
	if (!sel) return null;
	sel.innerHTML = '';
	assigned.forEach((t) => {
		const opt = document.createElement('option');
		opt.value = String(t.id);
		opt.textContent = t.nombre;
		opt.setAttribute('data-nombre', t.nombre);
		sel.appendChild(opt);
	});
	return sel;
}

function decorateMultiStoreUi(win, assigned, reopenModal) {
	const container = document.getElementById('tienda-selector-compacto');
	if (!container) return;
	container.style.background = '#E8F5E9';
	let changeBtn = document.getElementById('poskn-btn-cambiar-tienda');
	if (!changeBtn) {
		changeBtn = document.createElement('button');
		changeBtn.type = 'button';
		changeBtn.id = 'poskn-btn-cambiar-tienda';
		changeBtn.textContent = 'Cambiar';
		changeBtn.title = 'Elegir otra tienda de tu lista';
		container.appendChild(changeBtn);
	}
	changeBtn.onclick = () => {
		showTiendaSessionModal(win, assigned, (picked) => {
			applyTienda(win, picked);
			reopenModal && reopenModal();
		});
	};
}

export function initTiendaSelector(win, $) {
	if (win._posknTiendaSelectorInit) return;
	win._posknTiendaSelectorInit = true;

	win.posknTiendaBloqueada = win.posknTiendaBloqueada || false;
	win.posknTiendaSeleccionada = win.posknTiendaSeleccionada || null;
	win.posknTiendaStock = win.posknTiendaStock || {};

	$(document).on('change', '#tienda-selector', function onTiendaChange() {
		const sel = this;
		const raw = sel.value;
		const val = parseInt(raw, 10);
		const opt = sel.options[sel.selectedIndex];
		const nombre = (opt && (opt.getAttribute('data-nombre') || opt.textContent)) || '';
		if (!isNaN(val) && val >= 0 && raw !== '') {
			applyTienda(win, { id: val, nombre });
		} else {
			applyTienda(win, { id: 0, nombre: 'Tienda principal' });
		}
	});

	if (!win.POSKN_MULTITIENDA) {
		win.posknTiendaSeleccionada = null;
		win.posknTiendaStock = {};
		return;
	}

	const assignedRaw =
		win.posknUserTiendas && win.posknUserTiendas.length
			? win.posknUserTiendas
			: win.posknUserTienda
				? [win.posknUserTienda]
				: [];
	const assigned = normalizeAssigned(assignedRaw);

	if (assigned.length === 1) {
		const only = assigned[0];
		win.posknTiendaBloqueada = true;
		const container = document.getElementById('tienda-selector-compacto');
		if (container) {
			container.style.background = '#C8E6C9';
			container.innerHTML = `<span class="poskn-select-label" title="${escHtml(only.nombre)}">🏪 ${escHtml(only.nombre)}</span>`;
		}
		applyTienda(win, only, { skipRegisters: false });
		return;
	}

	if (assigned.length > 1) {
		win.posknTiendaBloqueada = false;
		fillAssignedSelect(assigned);
		decorateMultiStoreUi(win, assigned);

		const sessionId = readSessionTienda();
		const sessionOk =
			sessionId !== null && assigned.some((t) => t.id === sessionId);

		if (sessionOk) {
			const found = assigned.find((t) => t.id === sessionId);
			applyTienda(win, found);
			return;
		}

		// Nueva sesión o no elegida: pedir tienda (no asumir Principal)
		showTiendaSessionModal(win, assigned, (picked) => {
			applyTienda(win, picked);
		});
		return;
	}

	// Admin / sin asignación: todas las tiendas
	const adminAjax = win.posknAdminAjax;
	const dashNonce = win.posknDashNonce;
	if (!adminAjax || !dashNonce) return;

	$.ajax({
		url: adminAjax,
		method: 'POST',
		dataType: 'json',
		data: { action: 'poskn_get_tiendas', nonce: dashNonce },
		success(res) {
			if (!res.success || !res.data || !res.data.tiendas) return;
			const sel = document.getElementById('tienda-selector');
			if (!sel) return;
			const all = normalizeAssigned(res.data.tiendas);
			sel.innerHTML = '';
			all.forEach((t) => {
				const opt = document.createElement('option');
				opt.value = String(t.id);
				opt.textContent = t.nombre + (t.codigo && t.codigo !== 'principal' ? ` (${t.codigo})` : '');
				opt.setAttribute('data-nombre', t.nombre);
				sel.appendChild(opt);
			});

			const sessionId = readSessionTienda();
			let picked = null;
			if (sessionId !== null && all.some((t) => t.id === sessionId)) {
				picked = all.find((t) => t.id === sessionId);
			}
			if (!picked) {
				showTiendaSessionModal(win, all, (choice) => {
					applyTienda(win, choice);
				});
				return;
			}
			sel.value = String(picked.id);
			applyTienda(win, picked);
		},
	});
}
